import { defineComponent } from 'vue';
import { BodyFormCB } from './BodyFormCB';
import { setupComponent } from '@studyportals/vue-platform';
import { BodyFormModel } from './BodyFormModel';
import { IFormOperations } from './IFormOperations';

export default defineComponent({
	props: {
		formModel: BodyFormModel,
	},
	emits: {
		formReady: (_: IFormOperations) => true,
	},
	setup: (props, { emit }) => {
		const codeBehind = new BodyFormCB(props.formModel);
		emit('formReady', codeBehind);

		return setupComponent(codeBehind);
	},
});
